{
  "version": 1,
  "asset_id": "8c1652c0-4155-4671-8ff0-c5cc0b0af20a",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/8c1652c0-4155-4671-8ff0-c5cc0b0af20a/band-dilated-esophagus-annotated-1268.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/8c1652c0-4155-4671-8ff0-c5cc0b0af20a/band-dilated-esophagus-annotated-1268.webp",
  "original_filename": "band-dilated-esophagus-annotated-1268.webp",
  "size": 28974,
  "content_type": "image/webp",
  "created_at": "2026-09-26T01:40:06Z"
}
